export function getStatisticsDriverImage(
  player,
  currentSeasonYear,
  configData = {}
) {
  const { players = {} } = configData;

  const statView = players?.["stat-view"];
  const driverUrl = statView?.[player?.PlayerId];

  return driverUrl;
}

export function getStatisticsConstructorImage(
  player,
  currentSeasonYear,
  configData = {}
) {
  const { players = {} } = configData;

  const statView = players?.["stat-view"];
  const constructorUrl = statView?.[player?.PlayerId];

  return constructorUrl;
}

export function getPlayerPopupDriverImage(
  player,
  currentSeasonYear,
  configData = {}
) {
  const { players = {} } = configData;

  const playerPopup = players?.["player-popup"];

  const driverUrl = playerPopup?.[player?.PlayerId];

  return driverUrl;
}

export function getPlayerPopupConstructorImage(
  player,
  currentSeasonYear,
  configData = {}
) {
  const { players = {} } = configData;

  const playerPopup = players?.["player-popup"];

  const constructorUrl = playerPopup?.[player?.PlayerId];

  return constructorUrl;
}

export function getDriverListViewImage(
  player,
  currentSeasonYear,
  configData = {}
) {
  const { players = {} } = configData;

  const listView = players?.["list-view-web"];
  const driverUrl = listView?.[player?.PlayerId];

  return driverUrl;
}

export function getConstructorListViewImage(
  player,
  currentSeasonYear,
  configData = {}
) {
  const { players = {} } = configData;

  const listView = players?.["list-view-web"];
  const constructorUrl = listView?.[player?.PlayerId];

  return constructorUrl;
}

export function getDriverPitchViewImage(
  player,
  currentSeasonYear,
  configData = {}
) {
  const { players = {} } = configData;

  const pitchView = players?.["pitch-view"];
  const driverUrl = pitchView?.[player?.PlayerId];

  return driverUrl;
}

export function getConstructorPitchViewImage(
  player,
  currentSeasonYear,
  configData = {}
) {
  const { players = {} } = configData;

  const pitchView = players?.["pitch-view"];
  const constructorUrl = pitchView?.[player?.PlayerId];

  return constructorUrl;
}

export function getDriverHexViewImage(
  player,
  currentSeasonYear,
  configData = {}
) {
  const { players = {} } = configData;

  const hexView = players?.["hex-view"];
  const driverUrl = hexView?.[player?.PlayerId];

  return driverUrl;
}

export function getConstructorHexViewImage(
  player,
  currentSeasonYear,
  configData = {}
) {
  const { players = {} } = configData;

  const hexView = players?.["hex-view"];
  const constructorUrl = hexView?.[player?.PlayerId];

  return constructorUrl;
}

export function getBestPerformingDriver(
  player,
  currentSeasonYear,
  configData = {}
) {
  const { players = {} } = configData;

  const bestPerformance = players?.["best-performance"];

  const driverUrl = bestPerformance?.[player?.PlayerId];
  return driverUrl;
}

export function getBestPerformingConstructor(
  player,
  currentSeasonYear,
  configData = {}
) {
  const { players = {} } = configData;

  const bestPerformance = players?.["best-performance"];

  const constructorUrl = bestPerformance?.[player?.PlayerId];
  return constructorUrl;
}

export function getRaceWeekFlagPath(
  configData = {},
  cloudinaryBase = "https://alpha-media.formula1.com/image/upload",
  envVersion = "v1739888413",
  countryName
) {
  const raceweekFlagPath =
    configData?.imagePaths?.flagImg ||
    "<cloudinary_base_path>/<env_version>/common/f1/flag/flag<country_short_name>.png";
  const countryShortNames = configData?.countryShortNames || {
    Australia: "aus",
    Austria: "aus",
    Azerbaijan: "azer",
    Bahrain: "brn",
    Belgium: "bel",
    Brazil: "bra",
    Canada: "can",
    China: "chn",
    Hungary: "hun",
    Italy: "ita",
    Japan: "jap",
    Mexico: "mex",
    Monaco: "mon",
    Netherlands: "ned",
    Qatar: "qat",
    "Saudi Arabia": "ksa",
    Singapore: "sin",
    Spain: "esp",
    "United Arab Emirates": "uae",
    "United Kingdom": "gbr",
    "United States": "usa",
  };
  return raceweekFlagPath
    ?.replaceAll("<cloudinary_base_path>", cloudinaryBase)
    ?.replaceAll("<country_short_name>", countryShortNames?.[countryName])
    ?.replaceAll("<env_version>", envVersion);
}

export function getRaceWeekFlagPathForChart(
  configData = {},
  cloudinaryBase = "https://alpha-media.formula1.com/image/upload",
  envVersion = "v1739888413",
  countryName
) {
  const squareFlagCountryShortNames = ["chn"];
  const raceweekFlagPath =
    configData?.imagePaths?.flagImg ||
    "<cloudinary_base_path>/ar_1.0,c_fill,h_16/r_max/f_auto/<env_version>/common/f1/flag/flag<country_short_name>.png";
  const raceweekFlagSquarePath =
    "<cloudinary_base_path>/c_fill,h_16/f_auto/<env_version>/common/f1/flag/flag<country_short_name>.png";
  const countryShortNames = configData?.countryShortNames || {
    Australia: "aus",
    Austria: "aus",
    Azerbaijan: "azer",
    Bahrain: "brn",
    Belgium: "bel",
    Brazil: "bra",
    Canada: "can",
    China: "chn",
    Hungary: "hun",
    Italy: "ita",
    Japan: "jap",
    Mexico: "mex",
    Monaco: "mon",
    Netherlands: "ned",
    Qatar: "qat",
    "Saudi Arabia": "ksa",
    Singapore: "sin",
    Spain: "esp",
    "United Arab Emirates": "uae",
    "United Kingdom": "gbr",
    "United States": "usa",
    Miami: "usa",
    "Emilia-Romagna": "ita",
  };

  const countryShortName = countryShortNames?.[countryName];

  if (squareFlagCountryShortNames.includes(countryShortName)) {
    return raceweekFlagSquarePath
      ?.replaceAll("<cloudinary_base_path>", cloudinaryBase)
      ?.replaceAll("<country_short_name>", countryShortName)
      ?.replaceAll("<env_version>", envVersion);
  }

  return raceweekFlagPath
    ?.replaceAll("<cloudinary_base_path>", cloudinaryBase)
    ?.replaceAll("<country_short_name>", countryShortName)
    ?.replaceAll("<env_version>", envVersion);
}

export function getF1LogoPath(
  configData = {},
  cloudinaryBase = "https://alpha-media.formula1.com/image/upload",
  envVersion = "v1739888413",
  logoType = "red"
) {
  const redLogoPath =
    configData?.imagePaths?.f1LogoRed ||
    "<cloudinary_base_path>/<env_version>/common/logos/f1_logo_red.png";
  const whiteLogoPath =
    configData?.imagePaths?.f1LogoWhite ||
    "<cloudinary_base_path>/<env_version>/common/logos/f1_logo_white_pssdvx.png";

  if (logoType === "red") {
    return redLogoPath
      ?.replaceAll("<cloudinary_base_path>", cloudinaryBase)
      ?.replaceAll("<env_version>", envVersion);
  }

  return whiteLogoPath
    ?.replaceAll("<cloudinary_base_path>", cloudinaryBase)
    ?.replaceAll("<env_version>", envVersion);
}

export function getFIALogoPath(
  configData = {},
  cloudinaryBase = "https://alpha-media.formula1.com/image/upload",
  envVersion = "v1739888413",
  currentSeasonYear
) {
  const logoPath =
    configData?.imagePaths?.fiaLogo ||
    "<cloudinary_base_path>/<env_version>/Fantasy/<current_season_year>/images/client_header/fia_logo.svg";

  return logoPath
    ?.replaceAll("<cloudinary_base_path>", cloudinaryBase)
    ?.replaceAll("<env_version>", envVersion)
    ?.replaceAll("<current_season_year>", currentSeasonYear);
}

export function getF1TvLogoPath(
  configData = {},
  cloudinaryBase = "https://alpha-media.formula1.com/image/upload",
  envVersion = "v1739888413",
  currentSeasonYear,
  type = "dark"
) {
  const darklogoPath =
    configData?.imagePaths?.f1TvLogoDark ||
    "<cloudinary_base_path>/<env_version>/common/f1/logo/f1tv/logof1tvhorizontaldark.svg";
  const lightlogoPath =
    configData?.imagePaths?.f1TvLogoLight ||
    "<cloudinary_base_path>/<env_version>/Fantasy/<current_season_year>/images/client_header/logof1tvhorizontallight.svg";

  let logoPath = darklogoPath;
  if (type === "light") {
    logoPath = lightlogoPath;
  }

  return logoPath
    ?.replaceAll("<cloudinary_base_path>", cloudinaryBase)
    ?.replaceAll("<env_version>", envVersion)
    ?.replaceAll("<current_season_year>", currentSeasonYear);
}

export function getEOTMasterHeadBannerPath(
  configData = {},
  cloudinaryBase = "https://alpha-media.formula1.com/image/upload",
  envVersion = "v1739888413",
  currentSeasonYear,
  type = "desktop"
) {
  let masterHeadBannerPath;

  if (type === "desktop") {
    masterHeadBannerPath = configData?.imagePaths?.eotMasterHeaderDesktopBanner;
  } else if (type === "mobile") {
    masterHeadBannerPath = configData?.imagePaths?.eotMasterHeaderMobileBanner;
  }

  if (!masterHeadBannerPath) {
    return null;
  }

  return masterHeadBannerPath
    ?.replaceAll("<cloudinary_base_path>", cloudinaryBase)
    ?.replaceAll("<env_version>", envVersion)
    ?.replaceAll("<current_season_year>", currentSeasonYear);
}

export function getEOSRaceFlagPath(
  configData = {},
  cloudinaryBase,
  envVersion,
  currentSeasonYear,
  direction
) {
  const flagImagePath = configData?.imagePaths?.eosRaceFlag;

  return flagImagePath
    ?.replaceAll("<cloudinary_base_path>", cloudinaryBase)
    ?.replaceAll("<env_version>", envVersion)
    ?.replaceAll("<current_season_year>", currentSeasonYear)
    ?.replaceAll("<direction>", direction);
}

export function getTrackerCheckboardFlagPath(
  configData = {},
  cloudinaryBase,
  envVersion,
  currentSeasonYear
) {
  const flagImagePath = configData?.imagePaths?.trackerCheckboardFlag;

  return flagImagePath
    ?.replaceAll("<cloudinary_base_path>", cloudinaryBase)
    ?.replaceAll("<env_version>", envVersion)
    ?.replaceAll("<current_season_year>", currentSeasonYear);
}

export function getTrackerHelmetPath(
  configData = {},
  cloudinaryBase,
  envVersion,
  currentSeasonYear
) {
  const flagImagePath = configData?.imagePaths?.trackerHelmet;

  return flagImagePath
    ?.replaceAll("<cloudinary_base_path>", cloudinaryBase)
    ?.replaceAll("<env_version>", envVersion)
    ?.replaceAll("<current_season_year>", currentSeasonYear);
}

export function getTrackerPodiumPath(
  configData = {},
  cloudinaryBase,
  envVersion,
  currentSeasonYear
) {
  const flagImagePath = configData?.imagePaths?.trackerPodium;

  return flagImagePath
    ?.replaceAll("<cloudinary_base_path>", cloudinaryBase)
    ?.replaceAll("<env_version>", envVersion)
    ?.replaceAll("<current_season_year>", currentSeasonYear);
}
